import Cookie from 'cookie-universal'

// Workaround for sign out not working properly.
// In some cases when signing out, some in-flight requests would restore the session cookies, making it so it looked like you signed out (you were redirected to the pre-pw homepage), but trying to navigate to another page or reloading the page would get you immediately back in.
// With this workaround, we tell the BE that we are supposed to sign out, so it will clear the session correctly.
export const forceSignoutAndRedirect = (redirectUrl?: string) => {
  Cookie().set('force_signout', '1', { path: '/', maxAge: 60 })
  window.location.href = redirectUrl ?? '/'
}
